import { useEffect, useState } from 'react';

export type CheckboxFieldProps = {
  checked?: boolean;
  defaultChecked?: boolean;
  value?: boolean;
  onValueChange?: (value: boolean) => void;
};

const useCheckboxField = ({ checked, defaultChecked, value, onValueChange }: CheckboxFieldProps) => {
  const [isChecked, setIsChecked] = useState(defaultChecked ?? checked ?? value ?? false);

  useEffect(() => {
    setIsChecked(checked ?? value ?? false);
  }, [checked, value]);

  const onCheckboxChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updatedValue = event.target.checked;
    setIsChecked(updatedValue);
    onValueChange?.(updatedValue);
  };

  return { isChecked, onCheckboxChanged };
};

export default useCheckboxField;